import { useState, ChangeEvent, SyntheticEvent } from 'react';

type UseFormFieldType =
  | 'text'
  | 'tel'
  | 'email'
  | 'password'
  | 'checkbox'
  | 'textarea'
  | 'submit'
  | string;

type LabelPosType = 'left' | 'right';

interface IUseFormField {
  type?: UseFormFieldType;
  name?: string;
  placeholder?: string;
  value?: string | number;
  checked?: boolean;
  label?: string;
  labelPos?: LabelPosType;
  labelAfter?: string;
  required?: boolean;
  error?: boolean;
}
interface IUseForm {
  fields: Array<IUseFormField | null>;
  submit: (fields?: any) => void;
  onSubmit?: (cb: (hasErrors: boolean) => void) => void;
}

export const useForm = (args: IUseForm) => {
  const [fields, setFields] = useState(args.fields);

  const handleReset = () => {
    setFields(args.fields);
  };

  const handleSubmit = (e: SyntheticEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (typeof args.onSubmit === 'function') {
      args.onSubmit((hasErrors) => {
        validation((hasError) => {
          if (!hasError && !hasErrors) {
            args.submit(getFields(fields));
          }
        });
      });
    } else {
      validation((hasError) => {
        if (!hasError) {
          args.submit(getFields(fields));
        }
      });
    }
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const f = fields.map((item) => {
      if (item && item.name === e.target.name) {
        if (item.type === 'checkbox') {
          item = Object.assign({}, item, { checked: !item.checked });
        } else {
          item = Object.assign({}, item, { value: e.target.value });
        }
      }
      return item;
    });
    setFields(f);
  };

  const getFields = (arr: Array<any>) => {
    let obj = {};
    if (arr && arr.length) {
      arr.map((item: any) => {
        obj = Object.assign({}, obj, { [item.name]: item.value });
      });
    }
    return obj;
  };

  const validation = (cb: (hasError: boolean) => void) => {
    let hasError: boolean = false;
    const f = fields.map((item: any) => {
      if (item && item.required) {
        item.error = false;
        if (item.value === '') {
          item.error = true;
          hasError = true;
        }
        if (item.name === 'zip') {
          if (item.value.length === 4 && item.value.match(/[0-9]{4}/)) {
            item.error = false;
            hasError = false;
          } else {
            item.error = true;
            hasError = true;
          }
        }
        if (item.type === 'tel') {
          if (
            item &&
            item.value &&
            item.value.length >= 8 &&
            !isNaN(item.value)
          ) {
            item.error = false;
            hasError = false;
          } else {
            item.error = true;
            hasError = true;
          }
        }
        if (item.type === 'email') {
          const reg = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
          const value = (item && item.value && item.value) || '';
          if (reg.test(value.toString())) {
            item.error = false;
          } else {
            item.error = true;
            hasError = true;
          }
        }
      } else {
        item.error = false;
      }
      return item;
    });
    setFields(f);
    return cb(hasError);
  };
  return { fields, getFields, handleSubmit, handleChange, handleReset };
};
